import { countries, Country } from "countries-list";
import { sortCurrencyObjectByNameFunction } from "../../../../../../utils/format";

interface CountryWithAltSpellings extends Country {
  altSpellings?: string[];
}

const formatCountries = () => {
  const list = [];
  for (const [key, value] of Object.entries(countries)) {
    const country: CountryWithAltSpellings = value;
    list.push({
      value: value.name,
      label: value.name,
      code: key,
      altLabel: country.altSpellings?.join(", ") || "",
    });
  }

  return list.sort(sortCurrencyObjectByNameFunction);
};

export const countryOptions = formatCountries();

export const getCountryNameFromCode = (countryCode: string): string => {
  if (!countryCode) return "";

  const country = countries[countryCode.toUpperCase()];
  return country ? country.name : countryCode;
};
